(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ColorSamplerService', colorSamplerService);

    function colorSamplerService() {
        var canvas = null;
        var colorPicker = null;
        var fabricObject = null;
        var pickerType = 'fill'; // This can be 'fill' or 'outline'
        var backupHoverCursor = 'move';

        function startColorSampler(c, picker, object, type) {
            colorPicker = picker;
            fabricObject = object;
            pickerType = type;
            canvas = c;

            // Disable selection for all the objects in the canvas
            canvas.discardActiveObject();
            canvas.forEachObject(function (o) {
                o.selectable = false;
            });

            // Create a temporary element to set the cursor
            var e = document.createElement('div');
            e.style.position = 'fixed';
            e.style.opacity = '0';
            e.id = 'temp-cursor-element';
            document.body.appendChild(e);
            $('#temp-cursor-element').awesomeCursor('eyedropper', {
                hotspot: 'bottom left'
            });

            // Disable object selection
            canvas.selection = false;

            // Extract the CSS from the element
            canvas.defaultCursor = $('#temp-cursor-element').css('cursor');
            backupHoverCursor = canvas.hoverCursor;
            canvas.hoverCursor = canvas.defaultCursor;
            document.body.removeChild(e);
            canvas.renderAll();
        }

        function terminateColorSampler() {
            canvas.forEachObject(function (o) {
                o.selectable = true;
            });
            fabricObject = null;
            canvas.selection = true;

            // IMPORTANT: Due to a bug on Chrome and Safari, the cursor won't update until the user moves
            //  the mouse, there's no known workaround until this date to this bug.
            canvas.defaultCursor = '';
            canvas.hoverCursor = backupHoverCursor;
            canvas.renderAll();
        }

        function processColorSelection(event, callback) {
            canvas.selection = true;

            // Get the canvas color at the specified position from the event
            var color = canvas.getColorAt(event);

            // If transparent color, make it white
            if (color.a == 0) {
                color.r = color.g = color.b = 255;
            }

            function componentToHex(c) {
                var hex = c.toString(16);
                return hex.length == 1 ? '0' + hex : hex;
            }
            function rgbToHex(r, g, b) {
                return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
            }

            // Set the color for the color picker too
            colorPicker.setColor(rgbToHex(color.r, color.g, color.b));

            if (callback && fabricObject) {
                // Call the callback with the selected color in hex format
                callback(colorPicker, pickerType, fabricObject);
                terminateColorSampler();
            } else {
                terminateColorSampler();
            }
        }

        /**
         * This creates a object with all the methods exposed by the customily-color-picker directive
         *  but the methods does nothing. This is to prevent errors when calling functions when the color
         *  picker is not used (like in step3) or not yet available.
         */
        function createEmptyColorPicker() {
            return {
                terminate: function () {},
                setColor: function () {},
                disable: function () {},
                enable: function () {},
                getColors: function () {},
                getColor: function () {},
                destroy: function () {}
            };
        }

        return {
            startColorSampler: startColorSampler,
            terminateColorSampler: terminateColorSampler,
            processColorSelection: processColorSelection,
            createEmptyColorPicker: createEmptyColorPicker
        };
    }
})();
